import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth/auth.guard';
import { CheckTFAGuard } from '@core/guards/check-tfa/check-tfa.guard';
import { CheckPasswordGuard } from '@core/guards/checkPassword/check-password.guard';
import { LoginTrueGuard } from '@core/guards/login-true/login-true.guard';
import { ErrorComponent } from '@core/pages/error/error.component';
import { LoginComponent } from '@core/pages/login/login.component';
import { TfaPageComponent } from '@core/pages/tfa-page/tfa-page.component';
import { RedirectionComponent } from '@core/pages/redirection/redirection.component';
import { HomeComponent } from '@modules/home/home.component';
import { ErrorPageComponent } from '@shared/components/error-page/error-page.component';
import { FilePreviewComponent } from '@shared/components/file-preview/file-preview.component';
import { NewTabComponent } from '@shared/components/new-tab/new-tab.component';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { ChangePasswordComponent } from '@core/pages/change-password/change-password.component';
export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: HomeComponent,
    loadChildren: () =>
      import('./modules/modules.module').then((m) => m.ModulesModule),
  },
  {
    path: 'document',
    canActivate: [AuthGuard],
    component: NewTabComponent,
  },
  {
    path: 'preview',
    canActivate: [AuthGuard],
    component: FilePreviewComponent,
  },
  {
    path: 'login',
    canActivate: [LoginTrueGuard],
    component: LoginComponent,
  },
  {
    path: 'login/redirect',
    component: RedirectionComponent,
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard, CheckPasswordGuard],
    component: ChangePasswordComponent,
  },
  {
    path: 'tfa',
    canActivate: [CheckTFAGuard],
    component: TfaPageComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: 'failure',
    component: ErrorPageComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
